"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _InputError = _interopRequireDefault(require("./InputError"));
var _InputHelpText = _interopRequireDefault(require("./InputHelpText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormInputText = props => {
  var _props$refProp2;
  const changeValue = value => {
    props.onChange(value);
  };
  if (props.floatingLabel) {
    var _props$refProp, _props$value;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-12 align-bottom col-sm-".concat(props.divColSize)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-floating mb-3"
    }, /*#__PURE__*/_react.default.createElement("input", {
      ref: (_props$refProp = props.refProp) !== null && _props$refProp !== void 0 ? _props$refProp : null,
      id: props.name,
      name: props.name,
      type: props.type,
      value: (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : "",
      className: (0, _classnames.default)(props.inputSizeClass, {
        "is-invalid": props.error
      }),
      onBlur: props.onBlur,
      onChange: e => changeValue(e.target.value),
      "aria-describedby": props.name + "Help",
      placeholder: props.placeholder
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: props.name,
      className: (0, _classnames.default)("", {
        "is-invalid": props.error
      })
    }, props.label), props.required === true && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ", /*#__PURE__*/_react.default.createElement("small", {
      className: "text-danger"
    }, "* Required field")), /*#__PURE__*/_react.default.createElement(_InputError.default, {
      error: props.error
    }), /*#__PURE__*/_react.default.createElement(_InputHelpText.default, {
      helpText: props.helpText
    })));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 align-bottom col-sm-".concat(props.divColSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group row ".concat(!props.hideBorder ? "border-bottom" : "", " pb-2")
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.name,
    className: (0, _classnames.default)("col-sm-12 m-0 pt-2 pb-2", {
      "is-invalid": props.error
    })
  }, props.label, props.required === true && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ", /*#__PURE__*/_react.default.createElement("small", {
    className: "text-danger"
  }, "* Required field"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    ref: (_props$refProp2 = props.refProp) !== null && _props$refProp2 !== void 0 ? _props$refProp2 : null,
    id: props.name,
    name: props.name,
    type: props.type,
    value: props.value === null ? "" : props.value,
    className: (0, _classnames.default)(props.inputSizeClass, {
      "is-invalid": props.error
    }),
    onBlur: props.onBlur,
    onChange: e => changeValue(e.target.value),
    "aria-describedby": props.name + "Help",
    placeholder: props.placeholder
  }), props.children)), /*#__PURE__*/_react.default.createElement(_InputError.default, {
    error: props.error
  }), /*#__PURE__*/_react.default.createElement(_InputHelpText.default, {
    helpText: props.helpText
  }))));
};
var _default = FormInputText;
exports.default = _default;